import { z } from 'zod';
import { isoDateStringSchema } from './common';

export const knowhowNoteSchema = z.object({
  id: z.string().min(1).max(200),
  title: z.string().min(1).max(500),
  tags: z.array(z.string()),
  body: z.string(),
  noteCreatedAt: isoDateStringSchema.nullable(),
  noteUpdatedAt: isoDateStringSchema.nullable(),
  syncedAt: isoDateStringSchema,
});
export type KnowhowNote = z.infer<typeof knowhowNoteSchema>;

export const knowhowNoteListItemSchema = knowhowNoteSchema.omit({ body: true });
export type KnowhowNoteListItem = z.infer<typeof knowhowNoteListItemSchema>;

export const upsertKnowhowNoteRequestSchema = z.object({
  title: z.string().min(1).max(500),
  tags: z.array(z.string()).default([]),
  body: z.string(),
  noteCreatedAt: isoDateStringSchema.nullable().optional(),
  noteUpdatedAt: isoDateStringSchema.nullable().optional(),
});
export type UpsertKnowhowNoteRequest = z.infer<typeof upsertKnowhowNoteRequestSchema>;
